const customerEditIcon = document.querySelector("#customer-edit-icon");
const customerInfoTable = document.querySelector("#customerInfoTable");
const customerEditFields = document.querySelector("#customerEditFields");
const customerEditForm = document.querySelector("#customerEditForm");
const cancelEditBtn = document.querySelector("#cancel-edit-btn");
const customerType = document.querySelector("#customer-type")?.value;
const customerId = document.querySelector("#customer-id")?.value;
const emailInput = document.querySelector('#email');
const customerEditBtn = document.querySelector("#submit-edit-btn");
const encarregadoFields = document.querySelector("#encarregado-fields");
const loaderModal = document.querySelector("#minha-conta-loader-modal");
const customerEditLink = document.querySelector("#customer-edit-text");
const continenteCardValue = document.querySelector("#continente_card")?.value;
const schoolYears = [];
let publicKey = null;

customerEditIcon?.addEventListener("click", (e) => {
    customerInfoTable.classList.add("hidden");
    customerEditFields.classList.remove("hidden");
});

cancelEditBtn?.addEventListener("click", (e) => {
    customerInfoTable.classList.remove("hidden");
    customerEditFields.classList.add("hidden");
});

document.addEventListener("DOMContentLoaded", async (e) => {

     const publicKeyRes = await fetch(`/apps/sonae-stores-app/public-key`, {
        method: "POST",
    });
    if (publicKeyRes.ok) {
        const publicKeyJson = await publicKeyRes.json();
        publicKey = publicKeyJson?.data?.key;
    }

    fetch('https://sonae-services.production.theloop.tech/forms/schools/details', {
        headers: {
          Client: 'note_forms',
          Authorization: 's6498+4qekeJFwTpZnUtOyaVbVR2CZkSa/h1Xzjj+XK0YZ/o+dKOd848hjR5Xiu/nNcGzpHGNOmFhi++J/fVGTZVQouI4vp+ONh8AYTLlCz293bdS0SQpVSdFFVTVFqv',
        }
    })
        .then((response) => response.json())
        .then((data) => {
            if (data?.school_years) schoolYears.push(...data.school_years);
            // console.log({schoolYears});
            
            const encarregadosBirthYearSelects = document.querySelectorAll("select[id^='encarregado-birth-date']");
            const encarregadosSchoolYearSelects = document.querySelectorAll("select[id^='encarregado-ano-escolar']");
    
            encarregadosBirthYearSelects.forEach((element) => {
                const currentValue = element.querySelector("option")?.value;
                const elementCount = element.dataset.count;
                const correspondingSchoolYearSelect = document.querySelector(`#encarregado-ano-escolar-${elementCount}`);

                const birthYearOptions = getBirthYearOptions();
                element.replaceChildren(...birthYearOptions);
                if (currentValue) {
                    element.value = currentValue;
                }
                element.addEventListener("input", (e) => handleEncarregadoDOB(e, correspondingSchoolYearSelect));
            });
            encarregadosSchoolYearSelects.forEach((element) => {
                const currentValue = element.querySelector("option")?.value;
                
                schoolYears.forEach((elem) => {
                    const option1 = document.createElement('option');
                    option1.value = elem;
                    option1.textContent = elem;

                    element.appendChild(option1);
                    if (currentValue) {
                        element.value = currentValue;
                    }
                });
            });
            // if (("Encarregado de Educação,Professor/Educador").includes(customerType)) {
            // }
            const cicloDeEnsinoSelect = document.getElementById('ciclo_de_ensino');
            if (cicloDeEnsinoSelect) {
                const cicloArr = [];
                const currentValue = cicloDeEnsinoSelect?.value;
                for (const [key, value] of Object.entries(data.teaching_cycles)) {
                    const option = document.createElement('option');
                    option.value = value;
                    option.textContent = key;
                    cicloArr.push(option)
                }
                cicloDeEnsinoSelect.replaceChildren(...cicloArr);
                if (currentValue) cicloDeEnsinoSelect.value = currentValue;
            }

            // Populate Area de Ensino
            const areaDeEnsinoSelect = document.getElementById('area_de_ensino');
            const areaDeEnsinoValue = document.querySelector('#area-de-ensino-value');
            const areaDeEnsinoContent = areaDeEnsinoValue?.textContent;
            if (areaDeEnsinoSelect) {
                const areaArr = [];
                const currentValue = areaDeEnsinoSelect?.value;

                for (const [key, value] of Object.entries(data.subjects)) {
                    const option = document.createElement('option');
                    option.value = key;
                    option.textContent = value;
                    areaArr.push(option);

                    if (!isNaN(+areaDeEnsinoContent) && key == +areaDeEnsinoContent) {
                        areaDeEnsinoValue.textContent = value;
                    }
                }
                areaDeEnsinoSelect.replaceChildren(...areaArr);
                if (currentValue) areaDeEnsinoSelect.value = currentValue;
            }
        });
    
    try {
        const email = (emailInput.value || "").toLowerCase();
        
        const encodedEmail = encodeURIComponent(email);
    
        const teacherRes = await fetch(`https://sonae-services.production.theloop.tech/forms/schools?email=${encodedEmail}`, {
            method: "GET",
            headers: {
                Client: 'note_forms',
                Authorization: 's6498+4qekeJFwTpZnUtOyaVbVR2CZkSa/h1Xzjj+XK0YZ/o+dKOd848hjR5Xiu/nNcGzpHGNOmFhi++J/fVGTZVQouI4vp+ONh8AYTLlCz293bdS0SQpVSdFFVTVFqv',
            }
        })
    
        if (!teacherRes.ok) {
            throw new Error("Error fetching Teacher details");
        } else {
            let sonaeBooksUserData = await teacherRes.json();
    
            if (sonaeBooksUserData?.name){
                // console.log({sonaeBooksUserData});
                document.querySelector("#complete-profile-link")?.classList.add("hide");

                if (customerEditLink) customerEditLink.style.display = "inline-flex";

                if (customerType?.toLowerCase()?.includes("professor")) {
                    const areaDeEnsinoValue = document.querySelector('#area-de-ensino-value');
                    const areaDeEnsinoOption = document.querySelector(`#area_de_ensino option[value="${sonaeBooksUserData.subject}"]`);
        
                    if (areaDeEnsinoValue) {
                        areaDeEnsinoValue.textContent = sonaeBooksUserData?.subject;
                    }
                    if (areaDeEnsinoOption) {
                        areaDeEnsinoOption.setAttribute("selected", "true");
                    }
                }

                if (!continenteCardValue) {
                    document.querySelector("#continente_card").value = sonaeBooksUserData?.continente_card;
                }
            }
        }

    } catch (error) {
        console.error(error);
    }

    if (continenteCardValue && publicKey) {
        const continenteCard = await encryptWithPublicKey(publicKey, continenteCardValue);

        const vouchersRes = await fetch(`/apps/sonae-stores-app/cc-vouchers`, {
            method: "POST",
            body: JSON.stringify({ continente_card: continenteCard }),
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((res) => res.json())
        .catch((error) => {
            console.log(error);
        });

        console.log({ vouchersRes });
        const amountField = document.querySelector("#continente-card-details .amount");
        const pointsField = document.querySelector("#escola-note-points .amount");
        pointsField.textContent = `0`;

        if (vouchersRes?.data?.balance) {
            amountField.textContent = `${vouchersRes?.data?.balance?.total_amount_today || '0.00'}€`;
        } else {
            amountField.textContent = `0.00€`;
        }
        if (Array.isArray(vouchersRes?.data?.balance?.counter_details)) {
            const pointsData = vouchersRes?.data?.balance?.counter_details?.find((counter) => {
                return counter.counter.toLowerCase() == "i01";
            });
            if (pointsData) {
                pointsField.textContent = `${pointsData?.available_amount || '0'}`;
            }
        }

        const promoSection = document.querySelector("#promo-section");
        promoSection.classList.remove("hide");
        const pointsSection = document.querySelector("#escola-note-points");
        pointsSection.classList.remove("hide");

        if (vouchersRes?.data?.vouchers && vouchersRes?.data?.vouchers?.length > 0) {
            const sampleVoucher = document.querySelector("#vouchers-list .voucher-item");
            
            const voucherElements = vouchersRes?.data?.vouchers.map((voucher) => {
                const newVoucher = sampleVoucher.cloneNode(true);
                newVoucher.querySelector(".brand-img img").src = voucher.graphics?.brandImage;
                newVoucher.querySelector(".voucher-img img").src = voucher.graphics?.promotionImage;
                newVoucher.querySelector(".voucher-text").textContent = voucher?.message;
                newVoucher.querySelector(".voucher-id").textContent = voucher?.voucherId;

                const startDateYr = new Date(voucher?.startDate).getFullYear();
                const endDateYr = new Date(voucher?.endDate).getFullYear();
                const startDateDay = new Date(voucher?.startDate).getDate();
                const startDateMonth = new Date(voucher?.startDate).toLocaleDateString("pt-PT", {month: 'long'});
                const endDateDay = new Date(voucher?.endDate).getDate();
                const endDateMonth = new Date(voucher?.endDate).toLocaleDateString("pt-PT", {month: 'long'});
                if (startDateYr == endDateYr) {
                    newVoucher.querySelector(".voucher-date").textContent = `De ${startDateDay} ${startDateMonth} a ${endDateDay} ${endDateMonth} ${startDateYr}`;
                } else {
                    newVoucher.querySelector(".voucher-date").textContent = `De ${startDateDay} ${startDateMonth} ${startDateYr} a ${endDateDay} ${endDateMonth} ${endDateYr}`;
                }

                return newVoucher;
            });

            document.querySelector("#vouchers-list")?.replaceChildren(...voucherElements);
            document.querySelector(".vouchers")?.classList.remove("hide");
        }
    }

    //Edit link action
    customerEditLink?.addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(".save-edit-div").classList.remove("hide");
        customerEditFields.classList.remove("hidden");
    });
});


function handleEncarregadoDOB(e, schoolYearSelectElement) {
    const dobInput = e.target.value;
    const ageArr = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
    
    const studentAge = calculateAge(dobInput);
    const studentAgeIndex = ageArr.indexOf(studentAge);

    if (dobInput == "Anterior a 2001") {
        block.querySelector("select option[value='Ensino Superior']")?.setAttribute("selected", "true")
        return;
    }

    schoolYearSelectElement.querySelectorAll(`option`).forEach((opt) => {
        if (opt.value.startsWith(`${studentAgeIndex}º`)){
            opt.setAttribute("selected", "true");   
        } else {
            opt.removeAttribute("selected");
        }
    });

    if (studentAge > 18) {
        schoolYearSelectElement.querySelector("option[value='Ensino Superior']")?.setAttribute("selected", "true")
    }

    if (studentAge < 7) {
        schoolYearSelectElement.querySelector("option[value='Pré-Escolar']")?.setAttribute("selected", "true")
    }

}

function getBirthYearOptions() {
    const currentYear = new Date().getFullYear();
    const optionsArr = [];

    for (let yr = currentYear; yr > 2000; yr--) {
        let option = document.createElement("option");
        option.value = yr;
        option.textContent = ''+yr;
        optionsArr.push(option);
    }

    let option1 = document.createElement("option");
    option1.value = "Anterior a 2001";
    option1.textContent = "Anterior a 2001";
    optionsArr.push(option1);

    return optionsArr;
}

function calculateAge(dobInput) {

    const dob = new Date(dobInput);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust the age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
    }

    return age;
}

async function updateCustomerInformation() {
    customerEditBtn.setAttribute("disabled", "true");
    loaderModal.show();

    const customerType = document.querySelector("#customer-type")?.value;
    const customerFormData = new FormData(customerEditForm);
    const customerFormObj = {
        email: emailInput.value || "",
        metafields: {
            "continente_card": continenteCardValue,
            "customer_type": customerType,
        },
    };

    customerFormData.forEach((val, key) => {
        customerFormObj[key] = val;
    });

    switch (customerType) {
        case "Aluno":
            customerFormObj.metafields['ano_de_nascimento'] = document.querySelector("#encarregado-birth-date-1")?.value;
            customerFormObj.metafields['school_year'] = document.querySelector("#encarregado-ano-escolar-1")?.value;
            break;
        case "Professor Notavel":
            customerFormObj.metafields['ciclo_de_ensino'] = document.querySelector("#ciclo_de_ensino")?.value;
            customerFormObj.metafields['area_de_ensino'] = document.querySelector("#area_de_ensino")?.value;
            break;
        case "Professor/Educador":
            customerFormObj.metafields['ciclo_de_ensino'] = document.querySelector("#ciclo_de_ensino")?.value;
            customerFormObj.metafields['area_de_ensino'] = document.querySelector("#area_de_ensino")?.value;
        case "Encarregado de Educação":
            let encarregadoBirthDatesString = "";
            let encarregadoSchoolYearsString = "";
            document.querySelectorAll("select[id^='encarregado-birth-date']").forEach((elem) => {
                encarregadoBirthDatesString += `${encarregadoBirthDatesString.length > 0 ? "," : ""}${elem.value}`;
            });
            document.querySelectorAll("select[id^='encarregado-ano-escolar']").forEach((elem) => {
                encarregadoSchoolYearsString += `${encarregadoSchoolYearsString.length > 0 ? "," : ""}${elem.value}`;
            });
            customerFormObj.metafields['encarregado_birth_dates'] = encarregadoBirthDatesString;
            customerFormObj.metafields['school_year'] = encarregadoSchoolYearsString;
            customerFormObj.metafields['quantos_encarregado'] = document.querySelector("#quantos_encarregado")?.value;
            break;

        default:
            break;
    }

console.log({customerFormObj});
    const customerRes = await fetch(`https://sonae-shopify-app.production.theloop.tech/customeraccount?source=bazaar-noteonline.myshopify.com&isUpdate=true`, {
        method: "POST",
        body: JSON.stringify({data: customerFormObj}),
        headers: {
            "Content-Type": "application/json"
        }
    })
    .then((res) => res.json())
    .catch((error) => {
        console.log(error);
    });

    if (customerRes){
        customerEditBtn.removeAttribute("disabled");

        if (customerRes?.data?.success == false) {
            let errorMessage = customerRes?.data?.message || "Erro!";

            if (errorMessage.toLowerCase().includes("phone") && errorMessage.toLowerCase().includes("taken"))
            {
                errorMessage = "Número de telefone já utilizado";
            }
            // displayModalText(errorMessage, 3000);
        }
        else
        {
            setTimeout(() => {
                loaderModal.hide();
                window.location.reload();
            }, 5000);
        }
    }
}

customerEditBtn?.addEventListener("click", updateCustomerInformation);


document.querySelector("#quantos_encarregado")?.addEventListener("keyup", (e) => {
    let encarregadoQuantos = +e.target.value;

    if (!encarregadoQuantos || encarregadoQuantos < 0) {
        encarregadoQuantos = 1;
    } else if (encarregadoQuantos > 10) {
        encarregadoQuantos = 10
    }

    const currentEncarregadoBlocks = document.querySelectorAll(".encarregado-block");
    let blocksLen = currentEncarregadoBlocks?.length;

    if (blocksLen <= encarregadoQuantos) {

        for (let index = blocksLen+1; index <= encarregadoQuantos; index++) {
            createEncarregadoMetafieldElements(index);
        }
    } else {
        for (let index = encarregadoQuantos+1; index <= blocksLen; index++) {
            const elem = document.querySelector(`.encarregado-input-${index}`);
            encarregadoFields.removeChild(elem);
        }
    }

});

function createEncarregadoMetafieldElements (index, birthDateValue = "", schoolYearValue = "") {
    const encarregadoInputDiv = document.createElement("div");
    encarregadoInputDiv.classList.add("encarregado-block", `encarregado-input-${index}`);
    encarregadoInputDiv.dataset.number = index;

    const dateInputGroup = document.createElement("div");
    dateInputGroup.classList.add("account-customer-info");
    const dateInput = document.createElement("select");
    dateInput.setAttribute("name", `encarregado-birth-date-${index}`);
    dateInput.setAttribute("id", `encarregado-birth-date-${index}`);
    const birthYearOptions = getBirthYearOptions();
    dateInput.replaceChildren(...birthYearOptions);
    if (birthDateValue) {
        dateInput.value = birthDateValue;
    }

    const dateInputDiv = document.createElement("div");
    dateInputDiv.classList.add("info-value");
    dateInputDiv.appendChild(dateInput);

    const dateLabel = document.createElement("div");
    dateLabel.classList.add("info-title");
    dateLabel.textContent = `Ano do Nascimento Educando ${index}`;
    dateInputGroup.appendChild(dateLabel);
    dateInputGroup.appendChild(dateInputDiv);


    const yearSelectInput = document.createElement("div");
    yearSelectInput.classList.add("info-value");
    const schoolYearSelect = document.createElement("select");
    schoolYearSelect.setAttribute("name", `encarregado-ano-escolar-${index}`);
    schoolYearSelect.setAttribute("id", `encarregado-ano-escolar-${index}`);
    // schoolYearSelect.setAttribute("disabled", "true");
    schoolYears.forEach((elem) => {
        const option1 = document.createElement('option');
        option1.value = elem;
        option1.textContent = elem;

        if (schoolYearValue == elem) {
            option1.setAttribute("selected", "true");
        }

        schoolYearSelect.appendChild(option1);
    });
    const schoolYearSelectLabel = document.createElement("div");
    schoolYearSelectLabel.classList.add("info-title");
    schoolYearSelectLabel.setAttribute("for", `encarregado-ano-escolar-${index}`);
    schoolYearSelectLabel.textContent = `Ano Escolar Educando ${index}`;
    const hiddenSchoolYearDiv = document.createElement("div");
    yearSelectInput.appendChild(schoolYearSelect);
    hiddenSchoolYearDiv.classList.add("hidden");
    hiddenSchoolYearDiv.appendChild(schoolYearSelectLabel);
    hiddenSchoolYearDiv.appendChild(yearSelectInput);
        
    encarregadoInputDiv.appendChild(dateInputGroup);
    encarregadoInputDiv.appendChild(hiddenSchoolYearDiv);
    encarregadoInputDiv.addEventListener("input", (e) => handleEncarregadoDOB(e, encarregadoInputDiv));
    // encarregadoInputDiv.appendChild(selectInputRow);

    encarregadoFields.appendChild(encarregadoInputDiv);
}


function pemToArrayBuffer(pem) {
    const b64 = pem.replace(/-----(BEGIN|END) PUBLIC KEY-----/g, '').replace(/\n/g, '');
    const binaryDer = window.atob(b64);
    const bytes = new Uint8Array(binaryDer.length);
    for (let i = 0; i < binaryDer.length; i++) bytes[i] = binaryDer.charCodeAt(i);
    return bytes.buffer;
}

function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

async function encryptWithPublicKey(publicKey, message) {
    const keyArrayBuffer = pemToArrayBuffer(publicKey);
    const key = await window.crypto.subtle.importKey(
        'spki',
        keyArrayBuffer,
        {
            name: 'RSA-OAEP',
            hash: 'SHA-256'
        },
        false,
        ['encrypt']
    );
    const encoder = new TextEncoder();
    const messageArrayBuffer = encoder.encode(message);

    const encrypted = await window.crypto.subtle.encrypt(
        { name: 'RSA-OAEP' }, key, messageArrayBuffer
    );

    const encryptedBase64 = arrayBufferToBase64(encrypted);
    return encryptedBase64;
}